import { Button, type ButtonProps } from '@/shared/ui/button'

import type { FC } from 'react'

/**
 * Props for Block.Title.Action - inherits all Button props except 'size' which is forced to 'sm'
 */
export type BlockHeaderActionProps = Omit<ButtonProps, 'size'>

/**
 * Block.Title.Action - Action button placed on the right of the title
 */
export const BlockHeaderAction: FC<BlockHeaderActionProps> = ({
  variant = 'outline',
  intent = 'neutral',
  ...props
}) => {
  return <Button variant={variant} intent={intent} size="sm" {...props} />
}

BlockHeaderAction.displayName = 'BlockHeaderAction'
